/**
 * The one chip shape in the app: a tinted ground, a solid edge, and its label.
 *
 * `StatusTag`, the officer role chips and the share-register facts are the same
 * object wearing different colours, and they appear together — a member entry
 * can carry a role chip beside a status chip. Three files each writing their own
 * padding and radius is how they drift apart, so the geometry is stated once
 * here and the colour is passed in.
 *
 * Colour is NOT included: what a tone means is a decision per surface (a status
 * is something to act on, a role is a fact about a person), and folding both
 * into one map is what let a role end up wearing the "Paid" green.
 */
export const TAG_CLASSES =
  'inline-flex w-fit shrink-0 items-center gap-1 rounded-lg border px-2 py-0.5 text-xs leading-tight font-semibold';

/** For a chip stating a fact nobody has to act on — a register entry, a flag
 *  that is simply true or false. Grey, so it never reads as a status. */
export const TAG_NEUTRAL = 'bg-tag-neutral text-tag-neutral-ink border-tag-neutral-edge';
